import { promisify } from 'node:util';
import { brotliCompress } from 'node:zlib';
import { updateSiteUrl } from './urls.js';
const brotliCompressAsync = promisify(brotliCompress);
const sendUpdateSiteRequest = async (httpClient, request) => {
    const { data } = await httpClient.post(updateSiteUrl(), request);
    return data;
};
export const updateSite = async (httpClient, documentUpdate, branchId, revision) => {
    const stringifiedDocumentUpdate = JSON.stringify(documentUpdate);
    const compressedWmlSite = (await brotliCompressAsync(stringifiedDocumentUpdate)).toString('base64');
    const { updateSiteTaskId } = await sendUpdateSiteRequest(httpClient, {
        compressedWmlSite,
        branchId,
        revision
    });
    return updateSiteTaskId;
};
